import React from 'react';
import propTypes from 'prop-types';
import latLngDecimalToStandard from '../latLngDecimalToStandard';

export default class Address extends React.Component{
  static propTypes = {
    poi: propTypes.object.isRequired
  };

  render(){
    let {poi} = this.props;
    let { address, lat, lng } = poi.info;

    return(
      <div className="subfield address">
        <div className="left">地址</div>
        <div className='center'>
          <div onClick={this.handleClickAddress}>
            <address>{address}</address>
            <div className="geolocation">
              {latLngDecimalToStandard(lat, 'lat') + ', ' + latLngDecimalToStandard(lng, 'lng')}
            </div>
          </div>
        </div>
      </div>
    );
  }

  /**
   * 点击地址复制
   */
  handleClickAddress = (e)=>{
    this.props.handleClickAddress(e, this.props.poi.info);
  }

}



// WEBPACK FOOTER //
// ./src/components/Poi2/Introduction/Address.js